
































































































































import Vue from 'vue'
import {
  FETCH_PROJECT_WEB_REPORT,
  SAVE_PROJECT_WEB_REPORT
} from '@/store/action-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { TranslateResult } from 'vue-i18n'
import { SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import WebReportTransferDialog from '@/components/master-data/address/WebReportTransferDialog.vue'
import * as securityService from '@/services/security-service'


interface ComponentData {
  showTransferDialog: boolean

  reportData: any
  webReportPayload: any
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  option1: string[]
  option2: string[]
  option3: string[]
}

export default Vue.extend({
  name: 'WebReportProjekt',

  components: {
    ProgressCircular,
    WebReportTransferDialog
  },

  props: {
    show: Boolean,
    selectedProjectId: Number
  },

  data (): ComponentData {
    return {
      showTransferDialog: false,

      reportData: undefined,
      webReportPayload: undefined,
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      option1: [],
      option2: [],
      option3: []
    }
  },

  watch: {

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    showTransferButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.TransferButton)
    },

    disableTransferButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.TransferButton)
    }
  },

  methods: {
    onTransferClick (): void {
      this.showTransferDialog = true
    },

    onCloseTransferDialogClick (): void {
      this.showTransferDialog = false
    },

    transferSaved (): void {
      this.showTransferDialog = false
      this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true
    },

    transferError (): void {
      this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
      this.snackbarState = SnackbarStateEnum.Error
      this.showSnackbar = true
    },

    onCloseDialog (): void {
      this.$emit('close')
    },

    onField1Change (data: any): void {
      if(data) {
        const result: number =  this.webReportPayload.i_Wert010 ? parseFloat(this.webReportPayload.i_Wert010) + parseFloat(data) : parseFloat(data)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else {
        const result: number =  this.webReportPayload.i_Wert010 ? parseFloat(this.webReportPayload.i_Wert010) : 0
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      }
    },

    onField2Change (data: any): void {
      if(data) {
        const result: number = this.webReportPayload.i_Wert008 ? parseFloat(this.webReportPayload.i_Wert008) + parseFloat(data) : parseFloat(data)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else {
        const result: number = this.webReportPayload.i_Wert008 ? parseFloat(this.webReportPayload.i_Wert008) : 0
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      }
    },

    onFieldTotalChange (data: any): void {
      if(this.webReportPayload.i_Wert008 && this.webReportPayload.i_Wert010) {
        const result: number = parseFloat(this.webReportPayload.i_Wert008) + parseFloat(this.webReportPayload.i_Wert010)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else if (this.webReportPayload.i_Wert008 && !this.webReportPayload.i_Wert010) {
        const result: number = parseFloat(this.webReportPayload.i_Wert008)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else if (!this.webReportPayload.i_Wert008 && this.webReportPayload.i_Wert010) {
        const result: number = parseFloat(this.webReportPayload.i_Wert010)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else {
        this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
      }
    },

    onSaveClick (): void {
      for (const item in this.webReportPayload) {
        if(this.webReportPayload[item] === true) {
          this.webReportPayload[item] = "Ja"
        } else if(this.webReportPayload[item] === false) {
          this.webReportPayload[item] = ""
        }
      }

      const payload: any =  {
        ProjectId: this.selectedProjectId,
        FormName: "Pflichtenheft",
        Values: this.webReportPayload
      }

      this.saveWebReport(payload)
    },

    async saveWebReport (payload: any): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(SAVE_PROJECT_WEB_REPORT, payload)
        this.loading = false
        if(response.IsError) {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } else {
          this.$emit('saved')
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    setData (data: any): void {
      this.reportData = {
        headerLeft: [
          {id: 1, label: 'Adresse', value: 'SYZ AG Informatik\n' + 'Gewerbestrasse 18\n' + '8132 Egg bei Zürich'},
          {id: 2, label: 'Reparaturnummer', value: 'REP-123456'},
          {id: 3, label: 'Auftrag erteilt durch', value: 'Max Mustermann'},
          {id: 4, label: 'Material', value: 'gemäss Stückliste' },
          {id: 5, label: 'Gemeldete Störung', value: '' },
        ],

        headerRight: [
          {id: 7, label: 'Standort der Anlage', value: 'GH / MFH\n' + 'Musterstrasse 123\n' + '8000 Zürich'},
          {id: 8, label: 'Anlagenummer', value: ' EQ 3675'},
          {id: 9, label: 'Einsatz durchgeführt am', value: '01.02.2025'},
          {id: 10, label: 'Produktetyp', value: ''},
          {id: 11, label: 'Nachvollziehbar  ?', value: 'ja'},
        ],

        detailListLeft: [
          {id: 1, detailLabel: 'Arbeiten gem. Rapport inkl. bestellten Optionen', fieldList: [
              {id: 1, label: 'Ventil gemäss unten stehenden Arbeiten', value: 'true'},
              {id: 2, label: 'Zylinder gemäss unten stehenden Arbeiten', value: ''},
              {id: 3, label: 'Hydraulikleitung komplett inkl.Zubehör', value: ''},
              {id: 4, label: 'Öl filtrieren', value: 'true'},
              {id: 5, label: 'Ölwechsel', value: ''},
              {id: 6, label: 'Öl nachfiltrieren', value: ''},
              {id: 7, label: 'Schmutzfilteranbau inkl. Wartung nach 1 Jahr', value: 'true'},
              {id: 8, label: 'Handpumpe nachrüsten', value: ''},
              {id: 9, label: 'Zylinderersatz', value: ''},
              {id: 10, label: 'Aggregatersatz', value: ''},
          ]},
        ],

        detailListRight: [
          {id: 1, detailLabel: 'Detailliertere Auflistung', fieldList: [
              {id: 1, label: '', value: ''},
              {id: 2, label: '', value: ''},
              {id: 3, label: '', value: ''},
              {id: 4, label: '', value: ''},
              {id: 5, label: '', value: ''},
              {id: 6, label: '', value: ''},
              {id: 7, label: '', value: ''},
              {id: 8, label: '', value: ''},
              {id: 9, label: '', value: ''},
              {id: 10, label: '', value: ''},
            ]},
        ],

        detailListLeft2: [
          {id: 1, detailLabel: '', fieldList: [
              {id: 1, label: 'Leckagen', value: ''},
              {id: 2, label: 'Rohrbruchtest', value: ''},
              {id: 3, label: 'Ölzustand', value: ''},
              {id: 4, label: 'Zugang erschwert?', value: ''}
            ]},
        ],

        detailListRight2: [
          {id: 1, detailLabel: '', fieldList: [
              {id: 1, label: 'Entsorgung organisiert', value: ''},
              {id: 2, label: 'Protokoll ausgefüllt', value: ''},
              {id: 3, label: 'Garantie Vorbahalt?', value: ''},
              {id: 4, label: 'Empfehlungen', value: ''}
            ]},
        ],

        detailListLeft3: [
          {id: 1, detailLabel: '', fieldList: [
              {id: 1, label: 'An- und Rückreisezeit, Stunden', value: ''},
              {id: 2, label: 'Arbeitszeit, Stunden', value: ''},
            ]},
        ],

        detailListRight3: [
          {id: 1, detailLabel: '', fieldList: [
              {id: 1, label: 'Hin- und Rückfahrtdistanz, km', value: ''},
              {id: 2, label: 'Anzahl Techniker', value: ''},
            ]},
        ]
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_PROJECT_WEB_REPORT, this.selectedProjectId)
        this.loading = false
        if(response) {
          for (const key in response) {
            if(response[key] === 'Off') {
              response[key] = ''
            }
          }
          this.setData(response)
        }
      } catch (e) {
        this.loading = false
      }
    }
  },

  mounted () {
    this.setData(null)
    //this.fetchData()
  }
})
